import {useDispatch, useSelector} from "react-redux";
import numberFormat from "lib/numberFormat";
import {handleErrors} from "store/auth";
import {axiosInstance} from "../auth";
import { toJalali } from "lib/helpers";
export const UPDATE_FILED = "coreUpdateField";
export const CLEAR = "coreClear";

export const updateField = ({prop, value}) => ({
   type: UPDATE_FILED,
   payload: {prop, value},
});

export const useCore = () => {
   const core = useSelector((state) => state.core);
   const dispatch = useDispatch();
   return {
      ...core,
      list,
      clear,
      fetchList,
      getUsers,
      getRoles,
      getAbilities,
      dispatch,
      getCinemas,
      getHalls,
      getMovies,
      getMovieSections,
      getSanses
   };
};

function list(value) {
   return value.map((item) => {
      let data = {
         value: item.iso_code||item.id,
      };

      let label = item.organization_name || item.name || item.title || item.fa_name || item.full_name ||  "";
      // if user or agent => add last name & mobile
      if (item.first_name) {
         label = item.first_name;
         if (item.last_name) {
            label += " " + item.last_name;
         }
      }
      // if service & product add price
      if (item.price) {
         label += " (" + numberFormat.toOn(item.price) + " ریال)";
      }
      // if sans
      if (item.start_at) {
         label += " (" + toJalali(item.start_at,"HH:mm_jDD-jMM-jYY") + " )";
      }

      // add price for servie & product
      if (item.price) {
         data.price = item.price;
      }

      // add display name for role
      if (item.display_name) {
         label = item.display_name;
      }
      data.label = label;
      return data;
   });
}

export const clear = () => ({
   type: CLEAR,
});

async function fetchList(
   dispatch,
   filters,
   rel,
   key,
   route,
   disableList = false
) {
   try {
      dispatch(updateField({prop: `${key}Load`, value: true}));
      let url = `/panel/core/${route}?pagination=false&rel=${rel || ""}`;
      // handle filters

      if (filters) {
         Object.keys(filters).forEach((item) => {
            if (item.length <= 0) {
               return;
            }

            if (filters[item].length > 0 && Array.isArray(filters[item])) {
               filters[item].forEach((i, index) => {
                  url += `&${item}[${index}]=${i}`;
               });
            } else if (!!filters[item]) {
               url += `&${item}=${filters[item]}`;
            }
         });
      }
      const result = await axiosInstance.get(url);
      dispatch(
         updateField({
            prop: key,
            value: disableList ? result.data.data : list(result.data.data),
         })
      );
      dispatch(updateField({prop: `${key}Load`, value: false}));
   } catch (e) {
      dispatch(updateField({prop: `${key}Load`, value: false}));

      handleErrors(e);
   }
}

export const getUsers = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "users", "users");
};
export const getRoles = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "roles", "roles");
};
export const getCinemas = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "cinemas", "cinemas");
};
export const getHalls = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "halls", "halls");
};
export const getSanses = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "sanses", "sanses");
};
export const getMovies = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "movies", "movies");
};
export const getMovieSections = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "movieSections", "movie-sections");
};
export const getAbilities = (filters, rel) => async (dispatch) => {
   await fetchList(dispatch, filters, rel, "abilities", "abilities", true);
};
